import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { imgs } from "../../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { ModalInfoPromotionV2 } from "../../../components/common/ModalInfoPromotionV2";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { ModalInfo } from "../../../components/common/ModalInfo";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	viewActivities: 100,
	dialogTwo: 2,
	dialogThree: 3,
	dialogFour: 4,
	dialogFive: 5,
	dialogSix: 6,
	dialogSeven: 7,
	gameSubactivityOne: 8,
	instructionsTemporaryPromotions: 9,
	instructionsMaxBuy: 10,
	instructionsOptimizingExhibition: 11,
	instructions: 12,
	dialogEight: 13,
	dialogNine: 14,
	instructionsCheckout: 15, // letro model
	instructionsCocacola: 16, // letro model
	instructionsFastFood: 17, // letro model
	instructionsColdRoom: 18, // letro model
	instructionsSide: 19, // letro model
	instructionsCopeteHeader: 20, // letro model
	instructionsEntry: 21, // letro model
	evalation: 23, // final
	hiddenUI: 22,
};

const stepRayCaster = {
	Letrero_caja: steps.instructionsCheckout,
	Copete_coca: steps.instructionsCocacola,
	Letrero_fastFood: steps.instructionsFastFood,
	Letrero_cuartoFrio2: steps.instructionsColdRoom,
	Letreros1: steps.instructionsSide,
	Copete_dulces: steps.instructionsCopeteHeader,
	Letrero_puerta: steps.instructionsEntry,
};

export const SubtopicSixActivityOne = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const stepSelectRayCaster = useRef(0);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema6], 1);


	useEffect(() => {
		if (loaded) {
			console.log("subtema 6 Activity One");
			ObserverEmitter.emit(EVENTS.subtopicSix.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub06.sub6_act1_a01)
	})

	ObserverEmitter.on(EVENTS.subtopicSix.activityOne.clickedRayCaster, (step) => {
		const clickRayCaster = stepRayCaster[step];
		if (clickRayCaster === undefined) {
			return;
		}

		const isNextMove = stepSelectRayCaster.current === clickRayCaster;

		if (!isNextMove) {
			return;
		}

		if (clickRayCaster === steps.instructionsCheckout) {
			setUiToShow(steps.instructionsCheckout);
		}

		if (clickRayCaster === steps.instructionsCocacola) {
			setUiToShow(steps.instructionsCocacola);
		}

		if (clickRayCaster === steps.instructionsFastFood) {
			setUiToShow(steps.instructionsFastFood);
		}

		if (clickRayCaster === steps.instructionsColdRoom) {
			setUiToShow(steps.instructionsColdRoom);
		}

		if (clickRayCaster === steps.instructionsSide) {
			setUiToShow(steps.instructionsSide);
		}

		if (clickRayCaster === steps.instructionsCopeteHeader) {
			setUiToShow(steps.instructionsCopeteHeader);
		}

		if (clickRayCaster === steps.instructionsEntry) {
			setUiToShow(steps.instructionsEntry);
		}
	});

	const hiddenSelectObject = (stepCaster = 0) => {
		const foundEntry = Object.entries(stepRayCaster).find(([key, value]) => value === stepCaster);
		if (!foundEntry) {
			return;
		}
		const [key] = foundEntry;
		ObserverEmitter.emit(EVENTS.subtopicSix.activityOne.stepUseRayCaster, key);
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(steps.hiddenUI);
	};
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, steps.hiddenUI].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicSix.initScene, 1);
						stepSelectRayCaster.current = 0
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.hiddenUI && <></>}
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: PromOXXO." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Dentro de nuestras actividades a realizar encontramos, el colocar los banners de PromOXXO en la tienda."}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{steps.viewActivities === uiToShow && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 6: PromOXXO."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub06.sub6_act1_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.pensativo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"Debes prestar atención dónde va cada banner, ya que cada uno tiene su propio lugar."}
					percentage={"20%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub06.sub6_act1_a03)
						ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
						setUiToShow(steps.dialogThree);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogThree && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"Debes ser lo más observador y ordenado posible, y tomar en cuenta los siguientes puntos:"}
					percentage={"30%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub06.sub6_act1_a04)
						ObserverEmitter.emit(EVENTS.characterAnimations.idle);
						setUiToShow(steps.dialogFour);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogFour && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={
						"Condiciones del banner: debe estar en buenas condiciones y vigentes, en caso de que falte material o esté desgastado, repórtalo."
					}
					percentage={"40%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub06.sub6_act1_a05)
						setUiToShow(steps.dialogFive);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogFive && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={
						"Lugar estratégico: coloca el material en el lugar indicado, incentivando a la venta informando a los Clientes sobre las promociones. "
					}
					percentage={"40%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub06.sub6_act1_a06)
						setUiToShow(steps.dialogSix);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogSix && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={
						"Evitar sanciones: Las exhibiciones fueron pactadas con proveedores. Se debe colocar de manera correcta y evitar errores, para prevenir alguna sanción."
					}
					percentage={"50%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub06.sub6_act1_a07)
						setUiToShow(steps.dialogSeven);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogSeven && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"Tomando en cuenta los puntos vistos, veremos el siguiente video acerca de las promociones de OXXO."}
					percentage={"50%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						setUiToShow(steps.gameSubactivityOne);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.gameSubactivityOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<div className="fixed z-30 bottom-0 h-full w-full">
						<div className="w-full h-full flex justify-center items-center relative">
							<div className=" flex justify-center w-[400px] md:w-[800px] h-[225px] md:h-[450px] bg-[#282828] rounded-3xl md:rounded-[40px] p-2 md:p-4">
								<div className="h-full w-full bg-white rounded-2xl md:rounded-[24px] overflow-hidden"></div>
							</div>
							<div onClick={() => {
								ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
								setUiToShow(steps.instructionsTemporaryPromotions);
							}} className="absolute bg-yellow_primary h-[40px] w-[180px] md:w-[268px] md:h-[48px] rounded-2xl bottom-4 right-4 flex justify-center items-center">
								<p className="text-white text-[12px] md:text-[16px] font-semibold">Continuar</p>
							</div>
						</div>
					</div>
				</>
			)}
			{uiToShow === steps.instructionsTemporaryPromotions && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ModalInfoPromotionV2
						title={"Promociones Temporales"}
						description={
							"Promociones por un determinado periodo de tiempo, debe estar en buenas condiciones, y solo mantener las que estén vigentes. En caso de faltar material, o que esté desgastado, debe reportarse"
						}
						url={imgs.imagePromo1}
						callback={() => {
							setUiToShow(steps.instructionsMaxBuy);
						}}
					></ModalInfoPromotionV2>
				</>
			)}
			{uiToShow === steps.instructionsMaxBuy && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ModalInfoPromotionV2
						title={"Maximizando las Ventas"}
						description={
							"Es muy importante colocar este material en el lugar indicado ya que incentiva la venta e informa a los Clientes sobre promociones que pueden disfrutar y satisfacer sus necesidades."
						}
						url={imgs.imagePromo2}
						callback={() => {
							setUiToShow(steps.instructionsOptimizingExhibition);
						}}
					></ModalInfoPromotionV2>
				</>
			)}
			{uiToShow === steps.instructionsOptimizingExhibition && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ModalInfoPromotionV2
						title={"Optimizando la Exhibición"}
						description={
							"La exhibición de todo el material ha sido pactada con proveedores, por lo cual ellos pagan una comisión. Si no se coloca, o se hace de manera incorrecta, podemos hacernos acreedores de una sanción."
						}
						url={imgs.imageOptimizando}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub06.sub6_act1_a08)
							ObserverEmitter.emit(EVENTS.characterAnimations.showModel);
							setUiToShow(steps.instructions);
						}}
					></ModalInfoPromotionV2>
				</>
			)}
			{uiToShow === steps.instructions && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Inspecciona la tienda y encuentra todas las promociones, descubre a que tipo pertenece picando el banner."}
						percentage={"60%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogEight && (
				<>
					<PanelInstrucionHands
						text="Toca encima de los banners para obtener información."
						action={() => {
							ObserverEmitter.emit(EVENTS.subtopicSix.activityOne.moveBannerCheckout);
							// setUiToShow(steps.dialogNine);
							hiddenSelectObject(steps.instructionsCheckout);
						}}
						img={imgInstruction.sub6_act_1_01}
					/>
				</>
			)}
			{uiToShow === steps.instructionsCheckout && (
				<ModalInfo
					title="Check out"
					description="Los banners en el check out de OXXO captan la atención de los clientes durante sus compras al estar ubicados estratégicamente cerca de las cajas registradoras."
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicSix.activityOne.moveBannerCocacola);
						hiddenSelectObject(steps.instructionsCocacola);
					}}
				/>
			)}
			{uiToShow === steps.instructionsCocacola && (
				<ModalInfo
					title={"Copete Coca Cola"}
					description={
						"Los banners en el Copete Cabecera de OXXO están estratégicamente ubicados en la parte superior de los refiregadores de refrescos."
					}
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicSix.activityOne.moveBannerFastFood);
						hiddenSelectObject(steps.instructionsFastFood);
					}}
				/>
			)}
			{uiToShow === steps.instructionsFastFood && (
				<ModalInfo
					title={"Comida Rapida"}
					description={
						"Los banners en el área de comida rápida de OXXO promocionan nuestros productos y opciones de comida rápida con una ubicación estratégica."
					}
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicSix.activityOne.moveBannerColdRoom);
						hiddenSelectObject(steps.instructionsColdRoom);
					}}
				/>
			)}
			{uiToShow === steps.instructionsColdRoom && (
				<ModalInfo
					title={"Cuarto Frio"}
					description={
						"Los banners estratégicamente ubicados en el cuarto frio de nuestras tiendas captan la atención al mostrar promociones de bebidas ofertas especiales."
					}
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicSix.activityOne.moveBannerSide);
						hiddenSelectObject(steps.instructionsSide);
					}}
				/>
			)}
			{uiToShow === steps.instructionsSide && (
				<ModalInfo
					title={"Lateral"}
					description={
						"Los banners laterales de OXXO captan la atención de los transeúntes al estar estratégicamente ubicados en los costados de nuestras tiendas."
					}
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicSix.activityOne.moveBannerCopeteHeader);
						hiddenSelectObject(steps.instructionsCopeteHeader);
					}}
				/>
			)}
			{uiToShow === steps.instructionsCopeteHeader && (
				<ModalInfo
					title={"Copete Cabecera"}
					description={"Los banners en el Copete Cabecera de OXXO están estratégicamente ubicados en la parte superior de los anaquels."}
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicSix.activityOne.moveBannerEntry);
						hiddenSelectObject(steps.instructionsEntry);
					}}
				/>
			)}
			{uiToShow === steps.instructionsEntry && (
				<ModalInfo
					title={"Entrada"}
					description={
						"Los banners en la entrada de OXXO son estratégicamente ubicados para llamar la atención de los clientes desde el momento en que ingresan."
					}
					action={() => {
						setUiToShow(steps.evalation);
					}}
				/>
			)}
			{uiToShow === steps.evalation && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Presta mucha atención al colocar los banners para cumplir con los requisitos de estos."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema1.activities.subtema6,
								})
							);
							navigate("/home1/tema1/subtema6/activityresult");
						}}
					/>
				</>
			)}
		</>
	);
};
